import "./App.css";
import "./happy-admin-theme.css";
import { useLocation, Routes, Route } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import PrivateRouteAdmin from "./PrivateRouteAdmin";
import PrivateCustomer from "./PrivateCustomer";
import Login from "./pages/user/Login";
// Admin
import HistoryBetAll from "./pages/admin/HistoryBetAll";
import BankAdmin from "./pages/admin/BankAdmin";
import Dashboard from "./pages/admin/Dashboard";
import Request from "./pages/admin/Request";
import Users from "./pages/admin/Users";
import Refund from "./pages/admin/Refund";
import Add from "./pages/admin/Add";
import Khuyenmai from "./pages/admin/Khuyenmai";
import UserProfile from "./pages/admin/UserProfile";
import Promo from "./pages/admin/Promo";
import ThongBao from "./pages/admin/ThongBao";
import Setting from "./pages/admin/Setting";
import Config from "./pages/admin/Config";
import SettingNotify from "./pages/admin/SettingNotify";
import Employee from "./pages/admin/Employee";
import AllEmployee from "./pages/admin/AllEmployee";
import UsersByEmployee from "./pages/admin/UsersByEmployee";
import SettingProfit from "./pages/admin/SettingProfit";
import HoaHong from "./pages/admin/HoaHong";
import HistoryCasino from "./pages/admin/HistoryCasino";
import HistoryTransfer from "./pages/admin/HistoryTransfer";
import TraThuong from "./pages/admin/TraThuong";
import BankOut from "./pages/admin/BankOut";
import SetXD45s from "./pages/admin/SetXD45s";
import SetXD60s from "./pages/admin/SetXD60s";
import SetXS75s from "./pages/admin/SetXS75s";
import SetXS120s from "./pages/admin/SetXS120s";
import SetTX45s from "./pages/admin/SetTX45s";
import SetTX60s from "./pages/admin/SetTX60s";
import SetTXMD5 from "./pages/admin/SetTXMD5";
import SetTXLive from "./pages/admin/SetTXLive";
import SetXDLive from "./pages/admin/SetXDLive";
import SetGreedy from "./pages/admin/SetGreedy";
import SetCatDog from "./pages/admin/SetCatDog";
import OnlineUsers from "./pages/admin/OnlineUsers";
import Cleanup from "./pages/admin/Cleanup";
import ChatAdmin from "./pages/admin/Chat";
import AuditLogs from "./pages/admin/AuditLogs";
import Permissions from "./pages/admin/Permissions";
import Lobbies from "./pages/admin/Lobbies";
import LoginHistory from "./pages/admin/LoginHistory";
import GamePresets from "./pages/admin/GamePresets";
// Customer
import DashboardCustomer from "./pages/customer/DashboardCustomer";

import CustomerSetTX45s from "./pages/customer/SetTX45s";
import CustomerSetTX60s from "./pages/customer/SetTX60s";
import CustomerSetTXmd5 from "./pages/customer/SetTXMD5";
import CustomerSetXD45s from "./pages/customer/SetXD45s";
import CustomerSetXD60s from "./pages/customer/SetXD60s";
import CustomerSetXS75s from "./pages/customer/SetXS75s";
import CustomerSetXS120s from "./pages/customer/SetXS120s";

import UsersByEmployeeNV from "./pages/customer/UsersByEmployeeNV";
import HistoryBetAllCustomer from "./pages/customer/HistoryBetAllCustomer";
import HistoryCasinoCustomer from "./pages/customer/HistoryCasinoCustomer";
import DepositCustomer from "./pages/customer/DepositCustomer";
import WithdrawCustomer from "./pages/customer/WithdrawCustomer";
import RefundCustomer from "./pages/customer/RefundCustomer";
import PromoCustomer from "./pages/customer/PromoCustomer";
import AccountProfile from "./pages/customer/AccountProfile";
import AgencyWithdraw from "./pages/customer/AgencyWithdraw";

import { SystemSettingProvider } from "./context/SystemSettingContext";

function App() {
    const location = useLocation();
    return (
        <SystemSettingProvider>
            <div className="App">
                <Routes>
                    <Route element={<Login />} path="/" />
                    <Route element={<Login />} path="/login" />
                    
                    <Route path="/agency" element={<PrivateCustomer />}>
                        <Route element={<DashboardCustomer />} path="/agency" exact />
                        <Route element={<UsersByEmployeeNV />} path="/agency/users" exact />
                        <Route element={<DepositCustomer />} path="/agency/deposit" exact />
                        <Route element={<WithdrawCustomer />} path="/agency/withdraw" exact />
                        <Route element={<HistoryBetAllCustomer />} path="/agency/history" exact />
                        <Route element={<RefundCustomer />} path="/agency/refund" exact />
                        <Route element={<PromoCustomer />} path="/agency/giftcode" exact />
                        <Route element={<AccountProfile />} path="/agency/account" exact />
                        <Route element={<AgencyWithdraw />} path="/agency/my-withdraw" exact />
                    </Route>
                </Routes>
            </div>
        </SystemSettingProvider>
    );
}

export default App;
